import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import Link from "components/Link";
import useStyles from "./styles";

export interface Props {
  route: string;
  Icon: (props: any) => JSX.Element;
  label: string;
}

const LinkMenuItem = (props: Props) => {
  const { route, Icon, label } = props;
  const classes = useStyles();

  return (
    <Link className={classes.link} to={route}>
      <MenuItem>
        <ListItemIcon>
          <Icon fontSize="small" className={classes.menuIcon} />
        </ListItemIcon>
        <ListItemText primary={label} />
      </MenuItem>
    </Link>
  );
};

export default LinkMenuItem;
